import { PageRegisterView } from './page-register.view'

function PageRegister() {
  return (
    <PageRegisterView />
  )
}

export { PageRegister }
